// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LANFY3BSLfQa5LkROl0q{flex-direction:column;flex-grow:1;padding-bottom:24px;display:flex}.LANFY3BSLfQa5LkROl0q .mhVKDr_PumkmjAYT2kRO{justify-content:space-between;padding:30px 4px 17px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `LANFY3BSLfQa5LkROl0q`,
	"header": `mhVKDr_PumkmjAYT2kRO`
};
export default ___CSS_LOADER_EXPORT___;
